/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Accordion, $) {
	'use strict';

	/**
	 * Accordion single mode skin
	 * Allows only one tab to be open at a time
	 *
	 * @author TAASCRAA
	 * @namespace Tc.Module.Accordion
	 * @class SingleMode
	 * @extends Tc.Module.Accordion
	 */
	Accordion.SingleMode = function(parent) {
		this.setupAccordion = function($ctx) {
			parent.setupAccordion.apply(this, arguments);
			var first = this.tabs.filter('.scs-accordion-tab-opened').eq(0);
			if(!first.length) {
				// If no tab was open initially, we’ll use the first tab
				first = this.tabs.eq(0).addClass('scs-accordion-tab-opened');
			}
			this.tabs.not(first).removeClass('scs-accordion-tab-opened');
		};

		this.handleOpenTab = function(tab) {
			var mod = this;
			parent.handleOpenTab.apply(this, arguments);
			// Close all other tabs
			this.tabs.not(tab).each(function() {
				mod.closeTab($(this));
			});
		};

		this.handleCloseTab = function(tab) {
			if(this.tabs.not(tab).filter(function() {
				// Filter open or opening tabs
				return !!$(this).data(Accordion.DATA.TAB.IS_OPEN);
			}).length === 0) {
				// Don’t allow the last tab to close
				return;
			} else {
				parent.handleCloseTab.apply(this, arguments);
			}
		};
	};

}(window.Tc.Module.Accordion, window.Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Accordion.SingleMode.js
// module id = 128
// module chunks = 0